import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Space } from 'antd';
import { FormattedMessage } from 'react-intl';
import Drawer from 'components/Drawer';

import globalMessages from 'translations/messages';
import SegmentForm from '../SegmentForm';
import messages from '../messages';

const SegmentDrawer = ({ filterSegment, onSubmit, onRemove, onClose, onDuplicate, ...rest }) => {
  const [form] = Form.useForm();
  const [filterLoaded, setFilterLoaded] = useState(filterSegment.segment);
  const [saving, setSaving] = useState(false);
  const [removing, setRemoving] = useState(false);
  const [duplicating, setDuplicating] = useState(false);

  const isNewSegment = !filterSegment?.id;
  const isGlobalSegment = !!filterSegment.segment;
  const isEditable = !filterSegment?.createdByEmail;

  const handleRemove = async () => {
    setRemoving(true);
    await onRemove(filterSegment.id);
    setRemoving(false);
  };

  const handleSubmit = async (values) => {
    setSaving(true);
    await onSubmit(values);
    setSaving(false);
  };

  const handleDuplicate = async () => {
    setDuplicating(true);
    await onDuplicate(filterSegment.id);
    setDuplicating(false);
  };

  useEffect(() => {
    form.resetFields();
    setDuplicating(false);
    setSaving(false);
    setRemoving(false);
    setFilterLoaded(filterSegment.segment);
  }, [filterSegment]);

  return (
    <Drawer
      open={!!filterSegment}
      onClose={onClose}
      destroyOnClose
      width={600}
      title={filterSegment.friendlyTitle || <FormattedMessage {...messages.addSegment} />}
      footer={(
        <Row justify="space-between">
          <Col>
            {!isNewSegment && (
            <Button type="primary" onClick={handleDuplicate} loading={duplicating}>
              <FormattedMessage {...messages.duplicateSegment} />
            </Button>
            )}
          </Col>
          {isEditable && (
          <Col>
            <Space>
              {!isNewSegment && (
              <Button danger onClick={handleRemove} loading={removing}>
                <FormattedMessage {...globalMessages[isGlobalSegment ? 'remove' : 'delete']} />
              </Button>
              )}
              <Button
                onClick={form.submit}
                type="primary"
                loading={saving}
                disabled={!filterLoaded}
              >
                <FormattedMessage {...globalMessages.save} />
              </Button>
            </Space>
          </Col>
          )}
        </Row>
      )}
    >
      {filterSegment ? (
        <SegmentForm
          form={form}
          filterSegment={filterSegment}
          onSubmit={handleSubmit}
          isEditable={isEditable}
          isNewSegment={isNewSegment}
          onFilterLoaded={() => setFilterLoaded(true)}
          {...rest}
        />
      ) : null}
    </Drawer>
  );
};

export default SegmentDrawer;
